// extracted by mini-css-extract-plugin
export default {"bgLightGreen":"InvitationLinksTable_bgLightGreen__+OR2r"};